import angular from 'angular';

import CustomErrorDirective, { selector } from './custom-error.directive';

export default angular
    .module('application.directive.custom-error', [])
    .directive(selector, CustomErrorDirective);



// WEBPACK FOOTER //
// ./src/application/directive/custom-error/index.js